import * as React from 'react'

import { cn } from '@/utils'

export interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number
  max?: number
  /** Visual tone — MasterHub tokens only. */
  tone?: 'primary' | 'success' | 'warning' | 'destructive' | 'muted'
}

/**
 * Linear progress bar (Sprint T1 UX).
 */
export function Progress({
  className,
  value = 0,
  max = 100,
  tone = 'primary',
  ...props
}: ProgressProps) {
  const pct = max <= 0 ? 0 : Math.max(0, Math.min(100, (value / max) * 100))

  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={Math.round(pct)}
      className={cn('bg-muted h-2 w-full overflow-hidden rounded-full', className)}
      {...props}
    >
      <div
        className={cn(
          'h-full rounded-full transition-all duration-500 ease-out',
          tone === 'primary' && 'bg-primary',
          tone === 'success' && 'bg-success',
          tone === 'warning' && 'bg-warning',
          tone === 'destructive' && 'bg-destructive',
          tone === 'muted' && 'bg-foreground/25',
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  )
}
